import { useDispatch } from 'react-redux'

import { Typography } from '@material-ui/core'

import LimitationImage from 'assets/images/basic-limitation.png'

import { DialogBody } from './DialogBody'

import { logToAnalytics } from 'modules'
import { useRoles, useServiceUsage } from 'hooks'
import { showPlanDialog, showPlanNotifications } from 'ducks'

const blue = 'rgba(167, 210, 245, 0.9)'
const rose = 'rgba(190, 172, 222, 0.9)'

type Props = {
    onClose: () => void
    message?: string
}

export const BasicLimitationDialog = ({ onClose, message }: Props) => {
    const { isAdmin } = useRoles()

    const { usedPercent, isLoading } = useServiceUsage()
    const dispatch = useDispatch()

    if (isLoading) return null

    const initialMessage = (
        <>
            Your team reached{' '}
            <Typography component="span" style={{ color: '#cb0000' }}>
                {usedPercent}% of your Free
            </Typography>{' '}
            plan.
        </>
    )

    return (
        <DialogBody
            isOpen
            onClose={onClose}
            image={LimitationImage}
            bubblesBackground={[rose, blue]}
            onPrimaryClick={() => {
                logToAnalytics('open_upgrade_plan_dialog', {
                    source: 'basic_limitation_dialog'
                })
                dispatch(
                    showPlanNotifications({
                        freePlanLimitation: false
                    })
                )
                dispatch(showPlanDialog('upgradePlanDialog'))
            }}
            primaryText={isAdmin ? 'Upgrade plan' : 'Contact your admin'}
            title="Keep on going!"
            text={
                <Typography>
                    {message || initialMessage} Get unlimited videos minutes, video analytics and
                    more exciting features
                </Typography>
            }
        />
    )
}
